import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ProfileSummary from './components/ProfileSummary/ProfileSummary'
import ProfileDetail from './components/ProfileDetail/ProfileDetail'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { useParams } from 'react-router-dom'
import { useGetWorkerProfile } from './hooks/useGetWorkerProfile'
import { Error, Loader } from '../../components'
import { extractResponse } from '../../utils'
import { ProfileDetailProvider } from './context/ProfileDetailContext'

const useStyles = makeStyles((theme) => {
    return {
        container: {
            [theme.breakpoints.up('sm')]: {
                width: '80%',
            },
            margin: 'auto',
            marginTop: theme.spacing(4),
            minHeight: '90vh',
        },
        layout: {
            display: 'flex',
            alignItems: 'stretch',
        },
    }
})

function Profile() {
    const classes = useStyles()
    const { workerId, bookingId } = useParams()

    const { isLoading, data, error } = useGetWorkerProfile(workerId, bookingId)

    if (error) {
        return <Error error={error} />
    }

    const res = extractResponse(data)

    if (res?.error) {
        return <Error error={res?.error} />
    }

    const worker = res?.data

    console.log(worker)

    return (
        <Container className={classes.container}>
            {isLoading && <Loader />}
            {!isLoading && (
                <Grid container spacing={2} className={classes.layout}>
                    <ProfileSummary worker={worker} />
                    <ProfileDetailProvider>
                        <ProfileDetail worker={worker} />
                    </ProfileDetailProvider>
                </Grid>
            )}
        </Container>
    )
}

export default Profile
